import React from 'react';
import PropTypes from 'prop-types';
import FacetList from './FacetList';
import styles from './FilterByType.module.less';

const FilterByType = ({ facetObject, onClick }) => {
  if (!facetObject.children || !facetObject.hasChildren) return null;
  return (
    <li className={styles.section}>
      {facetObject.display != null && facetObject.display.length > 0 && (
        <h4 className={styles.title}>{facetObject.display}</h4>
      )}
      <FacetList
        facetsArray={facetObject.children}
        onClick={onClick}
        topLevel
      />
    </li>
  );
};

export default FilterByType;

FilterByType.propTypes = {
  facetObject: PropTypes.object,
  onClick: PropTypes.func,
};
